<div class="mct-flex mct-row mct-justify-start mct-items-start mct-gap-12" *ngIf="emailOptInData"   >
  <p-checkbox name="emailOptIn"/>
  <div>
    <p>{{ emailOptInData.Label }}</p>
    <div class="light-text" [innerHtml]="emailOptInData.Message | safeHtml"></div>
  </div>
</div>
